import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackClickedCopyTranscriptButton } from "@air/analytics/src/events/useTrackClickedCopyTranscriptButton";
import { memo, useCallback, useRef } from "react";
import { TranscriptSegmentHeader } from "~/components/AssetModal/shared/components/TranscriptPanel/components/TranscriptSegmentList/components/TranscriptSegment/components/TranscriptSegmentHeader";
import { TranscriptSegmentText } from "~/components/AssetModal/shared/components/TranscriptPanel/components/TranscriptSegmentList/components/TranscriptSegment/components/TranscriptSegmentText";
import { usePersistedOnScreen } from "~/components/AssetModal/shared/components/TranscriptPanel/components/TranscriptSegmentList/components/TranscriptSegment/hooks/usePersistedOnScreen";
import { useCopyTextToClipboard } from "~/hooks/useCopyTextToClipboard";
import { centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
export const TranscriptSegment = /*#__PURE__*/ memo((param)=>{
    let { segment, onSegmentPersistedOnScreen } = param;
    const store = useAirStore();
    const elementRef = useRef(null);
    const textRef = useRef(null);
    const { copyTextToClipboard } = useCopyTextToClipboard();
    const { trackClickedCopyTranscriptButton } = useTrackClickedCopyTranscriptButton();
    usePersistedOnScreen(onSegmentPersistedOnScreen ? ()=>onSegmentPersistedOnScreen({
            startTimeMs: segment.startTimeMs,
            endTimeMs: segment.endTimeMs
        }) : undefined);
    const onCopyTextClick = useCallback(()=>{
        var _textRef_current;
        const elementText = (_textRef_current = textRef.current) === null || _textRef_current === void 0 ? void 0 : _textRef_current.innerText;
        if (elementText) {
            trackClickedCopyTranscriptButton({
                clip_id: centralizedClipIdSelector(store.getState()),
                start_time_ms: segment.startTimeMs,
                end_time_ms: segment.endTimeMs
            });
            // each word is stored in a separate button element, so text will be separated by new lines
            const parsedText = elementText.replaceAll("\n", " ");
            copyTextToClipboard({
                text: parsedText
            });
        }
    }, [
        copyTextToClipboard,
        segment.endTimeMs,
        segment.startTimeMs,
        store,
        trackClickedCopyTranscriptButton
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        ref: elementRef,
        className: "group/segment flex flex-col gap-2 rounded p-2 hover:bg-grey-2",
        children: [
            /*#__PURE__*/ _jsx(TranscriptSegmentHeader, {
                segment: segment,
                onCopyTextClick: onCopyTextClick
            }),
            /*#__PURE__*/ _jsx(TranscriptSegmentText, {
                ref: textRef,
                segment: segment
            })
        ]
    });
});
TranscriptSegment.displayName = "TranscriptSegment";
